import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { useNavigate, useLocation } from "react-router-dom";

import {
  CompanyNameCell,
  getUserPlaceholder,
  renderValue
} from "utils/renderCompanyCell";
import { LinkText } from "components/SocialLinkDropdown/styled";
import StatusPillButtons from "components/Buttons/StatusPillButtons";

const columns = (onEdit, report) => {
  const columnHelper = createColumnHelper();
  const display_name = (row) => {
    const first = row?.creator_user?.first_name;
    const last = row?.creator_user?.last_name;
    if (!first && !last) return "—";
    return [first, last].filter(Boolean).join(" ");
  };

  return [
    columnHelper.accessor((row) => display_name(row), {
      id: "creator_name",
      header: "Campaign Reported By Creator",
      size: 250,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor(
      (row) => row.creator_user?.creator?.profile?.ig_handle,
      {
        header: "Creator's Instagram",
        size: 220,
        headerClassName: "table-header",
        cellClassName: "table-cell",
        enableSorting: false,
        cell: (info) => <>{renderValue(info.getValue())}</>
      }
    ),
    columnHelper.accessor((row) => row.user?.email, {
      header: "User Email",
      size: 150,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor("reason", {
      header: "Reason",
      size: 180,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),

    columnHelper.accessor((row) => row.marketplace_request?.id_hash, {
      header: "Campaign Link",
      size: 220,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => {
        const hash = info.getValue();
        if (!hash || hash === "—") return <>—</>;
        return (
          <>
            {
              <div
                className="link-text-pointer"
                onClick={() =>
                  window.open(
                    `https://hashfame.com/influencer-marketing-jobs/${hash}`,
                    "_blank"
                  )
                }
              >
                {info.getValue()}
              </div>
            }
          </>
        );
      }
    }),
    columnHelper.accessor("report_status", {
      header: "Status",
      size: 120,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => <StatusPillButtons status={info.getValue()} />
    }),
    columnHelper.accessor("actions", {
      header: "Actions",
      size: 160,
      headerClassName: "table-header",
      cellClassName: "table-cell table-link",
      enableSorting: false,

      // cell is a React component — safe to use hooks here
      cell: (info) => {
        return (
          <div className="table-link">
            <a onClick={() => onEdit(info.row.original)}>Review</a>
          </div>
        );
      }
    })
  ];
};

export default columns;
